import { render } from "./RichtextArticle.vue?vue&type=template&id=3e8f5461"
import script from "./RichtextArticle.vue?vue&type=script&lang=js"
export * from "./RichtextArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__